import { EnhancedAdBuilder } from './EnhancedAdBuilder/EnhancedAdBuilder';

const EnhancedAdBuilderDirective = (
  reactDirective,
  $state,
  AdMarkupService,
  CreativeService,
  FlashService,
  RenderService,
  SaveCreativeService
) => {
  return reactDirective(
    EnhancedAdBuilder,
    undefined,
    {
      restrict: 'E'
    },
    {
      $state,
      AdMarkupService,
      CreativeService,
      FlashService,
      RenderService,
      SaveCreativeService
    }
  );
};

EnhancedAdBuilderDirective.$inject = [
  'reactDirective',
  '$state',
  'AdMarkupService',
  'CreativeService',
  'FlashService',
  'RenderService',
  'SaveCreativeService'
];

export default EnhancedAdBuilderDirective;
